<template>
  <v-dialog v-model="show" max-width="600px">
    <v-card>
      <v-card-title primary-title> แก้ไขข้อความ </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-textarea
            v-model.trim="temptext"
            outlined
            name="input-7-4"
            :rules="[$store.getters.TextRule(temptext)]"
            clearable
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="(show = false), (temptext = message.text)"
          >ปิด</v-btn
        >
        <v-btn color="primary" outlined @click="ChangeText">ตกลง</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["visible", "message"],
  data() {
    return {
      temptext: null,
    };
  },
  mounted() {
    this.temptext = this.message.text;
  },
  watch: {
    visible(oldValue, newValue) {
      if (!newValue) {
        this.temptext = this.message.text;
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    ChangeText() {
      if (this.$refs.form.validate()) {
        this.message.text = this.temptext.trim();
        this.show = false;
      }
    },
  },
};
</script>
